import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import categoryAPI from "../../api/categoryApi";
import CategoryCard from "../categories/Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNext, setHasNext] = useState(true);

  /* First Load */
 

  const fetchCategories = async (currentPage) => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing({
        page: currentPage,
      });

      if (res.code === 200) {
        const { products, pagination } = res.data;

        setItems((prev) =>
          currentPage === 1
            ? products || []
            : [...prev, ...(products || [])]
        );

        setTotalCount(pagination?.total || 0);
        setHasNext(pagination?.hasNext || false);
        setHasMore(pagination?.hasNext || false);
      }
    } catch (err) {
      console.error("Error loading categories:", err);
    } finally {
      setLoading(false);
    }
  };

  /* Scroll Pagination */
  useEffect(() => {
    const onScroll = () => {
      if (
        !loading &&
        hasMore &&
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 200
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  /* Page Change */
   useEffect(() => {
    fetchCategories(1);
  }, []);
  
  useEffect(() => {
    if (page > 1) {
      fetchCategories(page);
    }
  }, [page]);

  return (
    <>
      <Breadcrump title="Category" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">

          <div className="blog-count text-left mb-4">
            Showing <b>{items.length}</b> of <b>{totalCount}</b> Categories
          </div>

          {items.length > 0 && (
            <div className="row g-3 mt-2">
              {items.map((item, index) => (
                <div
                  key={item._id || index}
                  className="col-lg-4 col-6"
                >
                  <CategoryCard item={item} />
                </div>
              ))}
            </div>
          )}

          {loading && (
            <div className="text-center mt-4">
              <p>Loading more categories...</p>
            </div>
          )}

          {!hasNext && !loading && items.length > 0 && (
            <div className="text-center mt-4">
              <p>✨ You’ve reached the end</p>
            </div>
          )}

        </div>
      </section>
    </>
  );
}

export default ListPage;